api = require('../api.coffee').api()

class global.UsersResource extends ResourceBase
  @MODEL = User
  @SINGULAR_RESOURCE_NAME = 'user'
  @PLURAL_RESOURCE_NAME = 'users'

  index: (success, failure, params={}) ->
    api.get '/users', params, { success: @collectionSuccess(success), failure }

  searchAccount: (success, failure, params={}) ->
    api.get('/users/search_account', params, {success: @memberSuccess(success), failure})

  inviteUser: (success, failure, params={}) ->
    api.post('/users/invitation', params, {success, failure})

  resendInviteUser: (success, failure, params={}) ->
    api.put('/users/invitation/resend', params, {success, failure})

  timezones: (success, failure, params={}) ->
    api.get('/users/timezones', params, {success, failure})

  get: (success, failure, params={}) ->
    api.get("/users/#{@getParamsId(params)}", {}, {success: @memberSuccess(success), failure})

  update: (success, failure, params) ->
    api.put("/users/#{@getParamsId(params)}", params, {success: @memberSuccess(success), failure})

  resetPassword: (success, failure, params)->
    api.put('/users/password', params, {success, failure})

  changePassword: (success, failure, params) ->
    api.put('/users/password/change', params, {success, failure})

  recoverPassword: (success, failure, params) ->
    api.post('/users/password', params, { success, failure })

  login: (success, failure, params) ->
    api.post('/users/sign_in', params, { success: @loginSuccess(success), failure })

  reloadSession: (callback, params) ->
    api.get("/users/#{@getParamsId(params)}", {}, { success: @loginSuccess(callback), failure: callback })

  generateUserHash: (success, failure, params={}) ->
    api.get('/users/generate_hash', params, { success, failure })

  loginSuccess: (success_callback) =>
    (response) =>
      Session.signIn response.body.user
      window.parent.postMessage { type: "created" }, "*" if window.parent
      success_callback response if success_callback

  activateInvitedUser: (success, failure, params) ->
    api.put('/users/invitation', params, {success, failure})

  destroy: (success, failure, params) ->
    api.delete("/users/#{@getParamsId(params)}", params, {success, failure})



// WEBPACK FOOTER //
// ./src/resources/users.coffee